import { useNavigate, useParams } from 'react-router-dom';
import './style.css';
import { useFormik } from 'formik';
import * as yup from 'yup';
import {
  Box,
  Button,
  FormHelperText,
  FormLabel,
  IconButton,
  Typography,
} from '@mui/material';
import CustomTextField from '../../Components/TextField';
import { useErrorHandler } from '../../hooks';
import logo from '../../Assets/Images/logo.png';
import ReactLoading from 'react-loading';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import useToggle from '../../hooks/use-toggle';
import { useState, useRef, useEffect } from 'react';
import {
  ResetPasswordAction,
  ClearAuthResponse,
} from '../../Redux/Actions/AuthActions';
import { useDispatch, useSelector } from 'react-redux';
import HelmetReact from '../../Components/Helmet';

export const ResetPassword = () => {
  const { token,value } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, success } = useSelector((state) => state.Auth);

  const [visiblePassword, setVisiblePassword] = useToggle(true);
  const [visibleConfirmPassword, setVisibleConfirmPassword] = useToggle(true);

  const { setMsgConfig } = useErrorHandler();

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      password: yup
        .string()
        .required('Please Enter Password')
        .min(3, 'characters must be more than 3')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
          'Password must have 8 characters,1 special character,1 UpperCase letter,1 LowerCase letter'
        ),

      confirmPassword: yup
        .string()
        .required()
        .oneOf([yup.ref('password'), null], 'Password Must Match'),
    }),
    onSubmit: (values) => {
      let payload = {
        token: token,
        new_password: formik.values.password,
        confirm_password: formik.values.confirmPassword,
      };
      dispatch(ResetPasswordAction(payload));
      !loading &&
        setMsgConfig({
          alertOpen: true,
          message: 'Password Change successfully!',
          severity: 'success',
          autoHideDuration: 2000,
        });
    },
  });
  useEffect(() => {
    dispatch(ClearAuthResponse());
  }, []);
  useEffect(() => {
    if (success == 'passChanged' && value==="patient") {
      navigate('/forgot-msg');
    }else if(success == 'passChanged'){
      navigate('/login');
    }
  }, [success, dispatch]);

  return (
    <>
      <HelmetReact name="Reset-Password" />
      <Box className="forget-passwordForm">
        <Box className="form-contianer">
          <Box className="logo">
            <img src={logo} className="brand-logo" alt=""></img>
          </Box>
          <Typography className="lable forget-password-header" variant="h3">
            Forget Password
          </Typography>
          <>
            <Box className="input forget-password-input">
              <FormLabel sx={{ display: 'flex' }}>New password *</FormLabel>
              <CustomTextField
                margin="normal"
                fieldType="simpleTextInput"
                type={visiblePassword ? 'password' : 'text'}
                variant="standard"
                required
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder={'Enter your Password'}
                error={
                  formik.touched.password && formik.errors.password
                    ? true
                    : false
                }
              />
              <IconButton className="toggle-eye" onClick={setVisiblePassword}>
                {visiblePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </IconButton>
              {formik.touched.password && formik.errors.password && (
                <FormHelperText className="error_message">
                  {formik.errors.password}
                </FormHelperText>
              )}
            </Box>
            <Box className="input forget-password-input">
              <FormLabel sx={{ display: 'flex' }}>Confirm password *</FormLabel>
              <CustomTextField
                margin="normal"
                fieldType="simpleTextInput"
                type={visibleConfirmPassword ? 'password' : 'text'}
                variant="standard"
                required
                name="confirmPassword"
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder={'Re-Enter Password'}
                error={
                  formik.touched.confirmPassword &&
                  formik.errors.confirmPassword
                    ? true
                    : false
                }
              />
              <IconButton
                className="toggle-eye"
                onClick={setVisibleConfirmPassword}
              >
                {visibleConfirmPassword ? (
                  <VisibilityIcon />
                ) : (
                  <VisibilityOffIcon />
                )}
              </IconButton>
              {formik.touched.confirmPassword &&
                formik.errors.confirmPassword && (
                  <FormHelperText className="error_message">
                    {formik.errors.confirmPassword}
                  </FormHelperText>
                )}
            </Box>
          </>

          <Box className="form-custom-btn forget-password-button">
            <Button variant="contained" onClick={formik.handleSubmit}>
              {loading ? (
                <Box className="outer_loader">
                  <ReactLoading
                    type={'spinningBubbles'}
                    height="30px"
                    width="30px"
                    color="#FFFFFF"
                  />
                </Box>
              ) : (
                'RESET PASSWORD'
              )}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};
